import { render, staticRenderFns } from "./EmailVerificationSuccess.vue?vue&type=template&id=e9b1a84a&scoped=true"
import script from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationSuccess.vue?vue&type=style&index=0&id=e9b1a84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b1a84a",
  null
  
)

export default component.exports